import { styled } from "@linaria/react";
import { EverGreenStyle } from "@utils/Style/everGreen";
import React, { useState } from "react";
import Icon from "@components/Icon";
import { css } from "@linaria/core";

interface card {
  padding?: string;
  marginTop?: string;
  backgroundColor?: string;
  width?: string;
  flexDirection?: string;
  opacityValue?: string;
}

const Card = styled.div<card>`
  background-color: ${(props) => props.backgroundColor || "white"};
  margin-top: ${(props) => props.marginTop || "30px"};
  max-width: ${(props) => props.width || "100%"};
  padding: ${(prop) => prop.padding || "24px"};
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  align-items: center;
  border-radius: 24px;
  overflow: hidden;
  opacity: ${(props) => props.opacityValue || 1};
  @media screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const TitleSm = styled.div`
  font-size: ${EverGreenStyle.title18};
  font-weight: 600;
  line-height: 140%;
  color: black;
`;

const IconPosition = css`
  transition: all 0.25s ease-in-out;
`;

const IconRotate = css`
  transform: rotate(180deg);
`;
const TitleContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
`;
const ContentNormal = css`
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  max-height: 0;
`;

const ContentExpand = css`
  max-height: 1000px;
  transition: max-height 1s ease-in-out;
`;

interface ICardComponent {
  padding?: string;
  children: any;
  flexDirection?: string;
  backgroundColor?: string;
  marginTop?: string;
  width?: string;
  className?: any;
  opacityValue?: string;
  title?: string;
  expanded?: boolean;
}

function CardComponent(prop: ICardComponent) {
  const [expanded, setExpanded] = useState<boolean>(prop.expanded || false);

  return (
    <Card {...prop}>
      <div
        onClick={() => setExpanded((prev) => !prev)}
        className={TitleContainer}
      >
        {prop.title ? <TitleSm>{prop.title}</TitleSm> : null}
        <div
          className={expanded ? `${IconRotate} ${IconPosition}` : IconPosition}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="5"
            viewBox="0 0 10 5"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.093 0C9.42709 0 9.5944 0.403928 9.35816 0.640165L5.26349 4.73484C5.11705 4.88128 4.87961 4.88128 4.73316 4.73484L0.638494 0.640164C0.402257 0.403928 0.569571 0 0.90366 0L9.093 0Z"
              fill="#434343"
            />
          </svg>
        </div>
      </div>

      <div
        className={
          expanded ? `${ContentExpand} ${ContentNormal}` : ContentNormal
        }
      >
        {prop.children}
      </div>
    </Card>
  );
}

export default CardComponent;
